export class EditorConfig {
	static config = {
		editable: true,
		spellcheck: true,
		height: 'auto',
		minHeight: '0',
		width: 'auto',
		minWidth: '0',
		translate: 'yes',
		enableToolbar: true,
		showToolbar: true,
		placeholder: 'Enter text here...',
		imageEndPoint: '',
		toolbar: [
			['cut', 'copy', 'delete', 'removeFormat', 'undo', 'redo'],
			['link', 'unlink'],
			['bold', 'italic', 'underline', 'strikeThrough'],
			['indent', 'outdent'],
			['orderedList', 'unorderedList'],
		],
	};
}
